import { observer } from "mobx-react";
import { Provider } from "@devowl-wp/real-product-manager-wp-client";
import { ConfigLicensingConsumer } from ".";
import React from "react";
const ConfigLicensing = observer(() => {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 800,
      margin: "auto",
      padding: "20px 0"
    }
  }, /*#__PURE__*/React.createElement(Provider, null, /*#__PURE__*/React.createElement(ConfigLicensingConsumer, null)));
});
export { ConfigLicensing };